package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.ms

val GalleryImageStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .fillMaxHeight()
            .objectFit(ObjectFit.Cover)
            .transition(
                Transition.of(
                    property = "transform",
                    duration = 300.ms,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
    }
}